import React, { useEffect, useState } from 'react'
import './bill-view.scss'
import { useNavigate, useParams } from 'react-router-dom'
import SinglePage from '../../components/common/page/SinglePage'
import SpinWithMessage from '../../components/common/spinners/SpinWithMessage'
import { accountingAxios } from '../../config/axios'
import { FaDotCircle } from 'react-icons/fa'
import { TbReceipt2 } from 'react-icons/tb'
import { BiLoaderAlt } from 'react-icons/bi'
import { formatStringDate, formatAmount} from '../../assets/javascript/formate-functions'



function ReceiptView() {
    const { receipt_uuid } = useParams()
    const [data, setData] = useState({})
    const navigate = useNavigate()
    const [loading, setLoading] = useState('fetch')
   

    
    const buildReceipt = async () => {

        if (!['VERIFIED', 'PARTIALLY_VERIFIED'].includes(data?.status)) {
            return;
        }

        setLoading('receipt')
        const res = await accountingAxios.get(`/p/download/pdf/receipt/rn/${data?.receipt_no}`, {
            responseType: "blob"
        })

        const blob = new Blob([res], {
            type: "application/pdf"
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = `receipt-${data?.receipt_no}.pdf`;
        link.click();

        window.URL.revokeObjectURL(url);

        setLoading('')
    }

    useEffect(() => {
        accountingAxios.get(`/v2/receipt/${receipt_uuid}`).then((response) => {
            if (response.data) {
                setData(response.data)
                setLoading('')
            } else {
                navigate('/')
                setLoading('')
            }
        })

        // eslint-disable-next-line
    }, [])

    return (
        <div className='single-bill-view'>
            <SinglePage titleArray={[`Receipt View / ${data?.receipt_no ?? 'Loading...'}`]}>
                {loading === 'fetch'
                    ? <SpinWithMessage message={'Fetch data...'} />
                    :
                    <>
                        <div className="top-div" style={{ justifyContent: 'flex-end' }}>
                            <div className="buttons-div">
                                <button onClick={() => navigate(`/transactions?receipt_no=${data?.receipt_no}`)}>Transactions</button>
                                <button onClick={() => navigate(`/allocations?receipt_no=${data?.receipt_no}`)}>Allocations</button>
                                {['VERIFIED', 'PARTIALLY_VERIFIED'].includes(data?.status) &&
                                    <button onClick={() => buildReceipt()} >{loading === 'receipt'
                                        ? <span className='loading-icon'><BiLoaderAlt /></span>
                                        : <TbReceipt2 />} Download</button>}
                            </div>
                        </div>
                        <div className="single-border">
                            <div className="section-one">
                                {/* Service Details */}
                                <div className="card-div">
                                    <div className="head-div">
                                        <FaDotCircle />
                                        <h4>About Receipt</h4>
                                    </div>
                                    <div className="content-div">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>Receipt No</td>
                                                    <td>: {data?.receipt_no}</td>
                                                </tr>
                                                <tr>
                                                    <td>Receipt Type</td>
                                                    <td>: {data?.receipt_type}</td>
                                                </tr>
                                                <tr>
                                                    <td>Date</td>
                                                    <td>: {data?.receipt_date ? formatStringDate(data?.receipt_date) : 'Nil'}</td>
                                                </tr>
                                                <tr>
                                                    <td>Direction</td>
                                                    <td>: {data?.direction} </td>
                                                </tr>
                                                <tr>
                                                    <td>Party Type</td>
                                                    <td>: {data?.party?.type} </td>
                                                </tr>
                                                <tr>
                                                    <td>Party Name & Id</td>
                                                    <td>: {data?.party?.id ?? ''}, {data?.party?.name ?? ''}</td>
                                                </tr>
                                                <tr>
                                                    <td>Collected By</td>
                                                    <td>: {data?.collected_by ? data?.collected_by : 'SYSTEM'} </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="card-div">
                                    <div className="head-div">
                                        <FaDotCircle />
                                        <h4>About Payment</h4>
                                    </div>
                                    <div className="content-div">
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>Total Amount</td>
                                                    <td>: ₹{formatAmount(data?.total_amount)}</td>
                                                </tr>
                                                <tr style={{ color: 'green', fontWeight: "600" }}>
                                                    <td>Verified Amount</td>
                                                    <td>: ₹{formatAmount(data?.verified_amount)}</td>
                                                </tr>
                                                <tr style={{ color: 'red', fontWeight: "600" }}>
                                                    <td>Pending Amount</td>
                                                    <td>: ₹{formatAmount(data?.pending_amount)}</td>
                                                </tr>
                                                <tr>
                                                    <td>Status</td>
                                                    <td>: <span className={` ${data?.status}-text text-badge`}>{data?.status}</span></td>
                                                </tr>
                                                <tr>
                                                    <td>Transactions</td>
                                                    <td>: {data?.tran_count} </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>}
            </SinglePage>
        </div >
    )
}

export default ReceiptView